const doc = [({"en":({"js":({"nemoa":({"layout":({"top_menu":({"index":({"sign_in":"Sign in"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;